import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import EntityStateHistory from '../../../graphql/queries/EntityStateHistory';
import LoadingOverlay from '../../Shared/LoadingOverlay';
import { getFieldValue } from '../../../helpers/serializers/Field'
import QRCodeHelper from '../../Shared/QRCodeHelper';
import {useTranslation} from "react-i18next";

const History = () => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        loadEntities();
    }, []);

    const loadEntities = (after = null) => {
        setIsLoading(true);

        EntityStateHistory.fetch()
            .then((response) => {
                setData(response.entityStateHistory);
            })
            .catch((error) => {
                console.error('Error fetching entities:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleOpenModal = (booking) => {
        setSelectedBooking(booking);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setSelectedBooking(null);
        setOpenModal(false);
    };

    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom>
                {t('profile.tabs.history.subtitle')}
            </Typography>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('profile.tabs.history.bookTitle')}</TableCell>
                            <TableCell>{t('profile.tabs.history.author')}</TableCell>
                            <TableCell>{t('profile.tabs.history.genre')}</TableCell>
                            <TableCell>{t('profile.tabs.history.date')}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.length < 1 && <LoadingOverlay isLoading={isLoading} />}
                        {/* Show Empty State when there's no data and not loading */}
                        {!isLoading && data.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <Typography variant="body1" color="textSecondary">
                                        No history available
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {data.map((entity) => (
                            <TableRow key={entity.id}>
                                <TableCell>{entity.entity.book?.title}</TableCell>
                                <TableCell>{entity.entity.book?.authors?.map(a => a.name).join(', ') || ''}</TableCell>
                                <TableCell>{entity.entity.book?.genre}</TableCell>
                                <TableCell>{new Date(entity.createdAt).toLocaleString()}</TableCell>
                                <TableCell>
                                    <Typography color={'error'}>
                                        {entity.action}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* QR Code Modal */}
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="qr-code-title"
            >
                <DialogTitle id="qr-code-title">
                    QR Code for {selectedBooking?.title}
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    {selectedBooking && (
                        <>
                            <Typography variant="body1" sx={{ mb: 2 }}>
                                Scan the QR code below to resolve your overdue status:
                            </Typography>
                            <QRCodeHelper
                                value={`https://your-library-url.com/book/${selectedBooking.id}`}
                                label="Scan the QR code below:"
                                size={150}
                            />
                            <Typography variant="body2" sx={{ mt: 2 }}>
                                {selectedBooking.book?.title}
                            </Typography>
                        </>
                    )}
                    <Button
                        variant="outlined"
                        sx={{ mt: 3 }}
                        onClick={handleCloseModal}
                    >
                        {t('close')}
                    </Button>
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default History;
